/**
 * Central registration file for all custom elements
 * Defines and registers all custom web components used throughout the application
 */

import { VisibilityElement } from './visibility'
import { ModalElement } from './modal'
import { InViewElement } from './in-view'
import { ReadMore } from './read-more'
import { StickyHeader } from './sticky-header'
import { MiniCart } from './mini-cart'
import { ProductForm } from './product-form'
import { VariantSelector } from './variant-selector'
import { EnhancedProductForm } from './enhanced-product-form'
import { QuantityInput } from './quantity-input'
import { Carousel } from './carousel'
import { StickyProductForm } from './sticky-product-form'
import 'snippets/notice-global/notice-global'
import { CustomForm } from '@/components/custom-elements/custom-form'
import { LightBoxElement } from '@/components/custom-elements/lightbox'
import { PinchZoomElement } from '@/components/custom-elements/pinch-zoom'
import 'snippets/navigation/localization-form'
import register from 'preact-custom-element'
import { ListDisplayElement } from '@/components/custom-elements/list-display'
import { ButtonElement } from './button'
import { CountdownElement } from './countdown'
import { GiftCardForm } from './gift-card-form'
import { BulkProductForm } from './bulk-product-form'
import { KlaviyoStarRatingElement } from './klaviyo-star-rating'
import { B2BPrice } from './b2b-price'
import { MarqueeElement } from './marquee'
import { TabbedContent } from './tabbed-content'
import { UniversalSizeSelector } from './universal-size-selector'
import { FreeShippingUSP } from './free-shipping-usp'
import { ScaStoreLocatorElement } from './sca-storelocator'
import { ConditionalCartContentElement } from './conditional-cart-content'
import { StorageModalElement } from './storage-modal'
import { VerticalCarouselElement } from './vertical-carousel'
import { CartLineVariantSelectorElement } from './cart-line-variant-selector'
import { GwpCartBlockElement } from './gwp-cart-block'
import { LottieAnimationElement } from './lottie-animation'
import { ShopTheLookElement } from './shop-the-look'
import { SwatchColourLabel } from './swatch-colour-label'
import { FilterToggle } from './filter-toggle'
import { BackToTopElement } from './back-to-top'
import { CustomerAddresses } from './customer-addresses'
import {
  AccountRecoverCancelLink,
  AccountRecoverForm,
  AccountRecoverLink
} from './account-form'
import { AccountNav } from './account-nav'
import { WishlistCount } from './wishlist-count'
import { WishlistToggle } from './wishlist-toggle'
import { BrauzBookAStylist } from './brauz-book-a-stylist'

register(MiniCart, 'mini-cart')
customElements.define('x-visibility', VisibilityElement)
customElements.define('x-lightbox', LightBoxElement)
customElements.define('x-pinch-zoom', PinchZoomElement)
customElements.define('x-modal', ModalElement)
customElements.define('x-in-view', InViewElement)
customElements.define('x-quantity-input', QuantityInput)
customElements.define('sticky-header', StickyHeader)
customElements.define('read-more', ReadMore)
customElements.define('product-form', ProductForm)
customElements.define('variant-selector', VariantSelector)
customElements.define('x-list-display', ListDisplayElement)
customElements.define('x-custom-form', CustomForm)
customElements.define('enhanced-product-form', EnhancedProductForm)
customElements.define('x-carousel', Carousel)
customElements.define('sticky-product-form', StickyProductForm)
customElements.define('x-button', ButtonElement)
customElements.define('x-countdown', CountdownElement)
customElements.define('gift-card-form', GiftCardForm)
customElements.define('bulk-product-form', BulkProductForm)
customElements.define('klaviyo-star-rating', KlaviyoStarRatingElement)
customElements.define('b2b-price', B2BPrice)
customElements.define('x-marquee', MarqueeElement)
customElements.define('x-tabbed-content', TabbedContent)
customElements.define('universal-size-selector', UniversalSizeSelector)
customElements.define('free-shipping-usp', FreeShippingUSP)
customElements.define('sca-storelocator', ScaStoreLocatorElement)
customElements.define('conditional-cart-content', ConditionalCartContentElement)
customElements.define('x-storage-modal', StorageModalElement)
customElements.define('x-vertical-carousel', VerticalCarouselElement)
customElements.define('cart-line-variant-selector', CartLineVariantSelectorElement)
customElements.define('gwp-cart-block', GwpCartBlockElement)
customElements.define('x-lottie', LottieAnimationElement)
customElements.define('shop-the-look', ShopTheLookElement)
customElements.define('swatch-colour-label', SwatchColourLabel)
customElements.define('filter-toggle', FilterToggle)
customElements.define('x-back-to-top', BackToTopElement)
customElements.define('x-customer-addresses', CustomerAddresses)
customElements.define('account-recover-form', AccountRecoverForm)
customElements.define('account-recover-link', AccountRecoverLink)
customElements.define('account-recover-cancel-link', AccountRecoverCancelLink)
customElements.define('x-account-nav', AccountNav)
customElements.define('x-wishlist-count', WishlistCount)
customElements.define('x-wishlist-toggle', WishlistToggle)
customElements.define('brauz-book-a-stylist', BrauzBookAStylist)
